import React, { useState } from "react";
import cx from "classnames";
import styles from "./assets/MultiSelect.module.css";

const MultiSelect = ({ field, formData, onChange, onOtherChange, placeHolder }) => {
    const [filteredLanguages, setFilteredLanguages] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const handleSearch = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        if (term.trim() === "") {
            setFilteredLanguages([]);
        } else {
            setFilteredLanguages(
                field.options
                    .filter((lang) => {
                        console.log("Checking language:", lang); // Log each lang object
                        return !lang.pin && !formData[field.name].includes(lang.value);
                    })
                    .filter((lang) => lang.name.toLowerCase().startsWith(term))
            );
        }
    };

    const onOptSelect = (selectedValue) => {
        setFilteredLanguages((prevFiltered) =>
            prevFiltered.filter((lang) => lang.value !== selectedValue)
        );
    };

    return (
        <div className={styles.multiSelectCont}>
            {field.options.length < 20 ? (
                field.options.map(option => (
                    <label key={option.value} className={styles.multipleSelectOption}>
                        <input
                            type="checkbox"
                            value={option.value}
                            name={field.name}
                            checked={formData[field.name].includes(option.value)}
                            onChange={onChange}
                        />
                        <span>{option.name}</span>
                    </label>
                ))
            ) : (
                <>
                    <input
                        type="text"
                        className={styles.searchBox}
                        value={searchTerm}
                        placeholder={placeHolder}
                        onChange={handleSearch}
                    />

                    {field.options
                        .filter(lang => lang.pin || formData[field.name].includes(lang.value))
                        .map(option => (
                            <label key={option.value} className={styles.multipleSelectOption}>
                                <input
                                    type="checkbox"
                                    value={option.value}
                                    name={field.name}
                                    checked={formData[field.name].includes(option.value)}
                                    onChange={onChange}
                                />
                                <span>{option.name}</span>
                            </label>
                        ))}

                    {searchTerm && filteredLanguages.length > 0 && (
                        filteredLanguages.map(option => (
                            <label key={option.value} className={cx(styles.multipleSelectOption, styles.searchTerm)}>
                                <input
                                    type="checkbox"
                                    value={option.value}
                                    name={field.name}
                                    checked={formData[field.name].includes(option.value)}
                                    onChange={(e) => {
                                        onChange(e); // Keep the existing onChange functionality
                                        onOptSelect(option.value); // Remove from search results when checked
                                    }}
                                />
                                <span>{option.name}</span>
                            </label>
                        ))
                    )}
                </>
            )}
            {
                formData[field.name]?.includes("Other") && (
                    <div className="">
                        <input
                            type="text"
                            name={`other_${field.name}`}
                            value={formData[`other_${field.name}`]}
                            onChange={onOtherChange}
                            className="form-control"
                            placeholder={`Enter other ${field.name.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`}
                        />
                    </div>
                )
            }
        </div>
    );
};

export default MultiSelect;
